module.exports = __webpack_public_path__ + "static/media/saas graphics.808721bd.png";